module.exports = __webpack_public_path__ + "Phbo_Banner.png?795266062c130904cf49be98bd72ea7b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ProductAndService/Phbo/Phbo_Banner.png
// module id = 146
// module chunks = 0